// extracted by mini-css-extract-plugin
module.exports = {"container":"a630f0e637--container--spXLa","phone":"a630f0e637--phone--vHoLc","phone-wrapper":"a630f0e637--phone-wrapper--CxOjT","phone-icon":"a630f0e637--phone-icon--lbPoG"};